module.exports = __webpack_public_path__ + "static/media/stripe-flowchart.8b6e7ade.png";